module.exports = __webpack_public_path__ + "img/unpublish.c9014351.svg";